import React, { useState, useEffect } from 'react';
import { Card, Tabs } from 'antd';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import LoanStatus from './LoanStatus';
import getPermissions from '../../utils/getPermissions';
import getUserFromToken from '../../utils/getUserFromToken';

const { TabPane } = Tabs;

const LoanStatusPage = () => {
    const [userRole, setUserRole] = useState('employee');
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Get user information from localStorage
        const currentUserId = getUserFromToken();
        const userPermissions = getPermissions();
        const userRoleFromStorage = parseInt(localStorage.getItem('roleId'));
        
        setUserId(currentUserId);
        
         // Determine user role based on permissions
         if (userPermissions && userPermissions.includes('readAll-attendance')) {
            if (userRoleFromStorage === 1 || userRoleFromStorage === 4 || userRoleFromStorage === 8 || userRoleFromStorage === 9) {
                setUserRole('admin');
            } else if (userRoleFromStorage === 5 || userRoleFromStorage === 6) {
                setUserRole('hr');
            } else if (userRoleFromStorage === 7){
                setUserRole('manager');
            } else{
                setUserRole('employee');
            }
        } else {
            setUserRole('employee');
        }
        
        setLoading(false);
    }, []);

    const isLogged = Boolean(localStorage.getItem("isLogged"));

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    const getPageTitle = () => {
        switch (userRole) {
            case 'admin':
                return 'Advance Status (Admin)';
            case 'hr':
                return 'Advance Status (HR)';
            case 'manager':
                return 'Advance Status (Manager)';
            default:
                return 'Advance Status';
        }
    };

    return (
        <>
            <PageTitle title='Back' />
            <Card title={getPageTitle()}>
                <LoanStatus userRole={userRole} userId={userId} />
            </Card>
        </>
    );
};

export default LoanStatusPage;
